import {MemexColumnDataType} from '../api/columns/contracts/memex-column'

const supportedServerSortByColumnDataTypes = [
  MemexColumnDataType.Assignees,
  MemexColumnDataType.Date,
  MemexColumnDataType.Labels,
  MemexColumnDataType.LinkedPullRequests,
  MemexColumnDataType.Number,
  MemexColumnDataType.SingleSelect,
  MemexColumnDataType.Text,
  MemexColumnDataType.Title,
  MemexColumnDataType.Labels,
] as Array<MemexColumnDataType>

export function canServerSortByColumnType(columnDataType: MemexColumnDataType) {
  return supportedServerSortByColumnDataTypes.includes(columnDataType)
}

const supportedServerFilterByColumnDataTypes = [
  MemexColumnDataType.Assignees,
  MemexColumnDataType.Date,
  MemexColumnDataType.Labels,
  MemexColumnDataType.LinkedPullRequests,
  MemexColumnDataType.Number,
  MemexColumnDataType.SingleSelect,
  MemexColumnDataType.Text,
  MemexColumnDataType.Title,
] as Array<MemexColumnDataType>

export function canServerFilterByColumnType(columnDataType: MemexColumnDataType) {
  return supportedServerFilterByColumnDataTypes.includes(columnDataType)
}

const supportedServerGroupByColumnDataTypes = [
  MemexColumnDataType.Assignees,
  MemexColumnDataType.Date,
  MemexColumnDataType.Iteration,
  MemexColumnDataType.Number,
  MemexColumnDataType.SingleSelect,
  MemexColumnDataType.Text,
] as Array<MemexColumnDataType>

export function canServerGroupByColumnType(columnDataType: MemexColumnDataType) {
  return supportedServerGroupByColumnDataTypes.includes(columnDataType)
}
